import React, { Component } from 'react';
import * as ItemDetailNewAction from '../actions/ItemDetailNewAction';
import * as AltPartDetailsAction from '../actions/AltPartDetailsAction';
import AltPartDetailsStore from '../stores/AltPartDetailsStore';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import swal from 'sweetalert';
import ImageGallery from 'react-image-gallery';
import Switch from '@material-ui/core/Switch';
import Image from 'react-image-resizer';
import { borderBottom } from '@material-ui/system';
let ItemImageValue = ""
class AlternatepartsComponent extends Component {
    constructor(props) {
        super(props);
        this.bindAltParts = this.bindAltParts.bind(this)
        this.bindUnAvailItems = this.bindUnAvailItems.bind(this)
        //[2/22/2023, Bug - 3127, Dhevanesam R]
        this.bindUnavailParts = this.bindUnavailParts.bind(this);
        this.bindImage = this.bindImage.bind(this);
        this.state = {
            flagTable: this.props.flagTable,
            altDetails: this.props.altDetails,
            nonCatItemDetails: [],
            isAltDetailClick: false,
            IsDotClick: false,
            Description: "Long Description",
            isFullScreen: false,
        }
    }
    componentWillMount() {
        this.setState({ isAltDetailClick: false })
    }
    componentDidMount() {
        AltPartDetailsStore.on('AddtoCartResponse', this.altPartstoCartResponse);
        AltPartDetailsStore.on("altPartDetailsResponse", this.altPartDetailsResponse.bind(this));
    }
    componentWillUnmount() {
        AltPartDetailsStore.removeListener('AddtoCartResponse', this.altPartstoCartResponse);
        AltPartDetailsStore.removeListener("altPartDetailsResponse", this.altPartDetailsResponse);
    }
    handleScreenChange = (fullScreenElement) => {
        
        this.setState({ showThumbnails: !this.state.showThumbnails, showBullets: !this.state.showBullets, isFullScreen: !this.state.isFullScreen })
    };
    bindImage = () => {
        
        const style = {
            image: {
                position: 'sticky !important',
                display: 'block',
                left: '0px !important',
                top: '0px !important',
            },
        }
        let imageurl = this.state.ItemImage
        if (imageurl != null && imageurl != "") {
            if (imageurl.includes("NoImageAvailable")) {
                imageurl = `Images/noimage_new.png`;
            }
        }
        let showBullets = false;
        let showIndex = false;
        if (this.state.ItemImage.length > 1) {
            showBullets = true
            showIndex = true
        }
        console.log("imageurl", imageurl)
        return (
            <ImageGallery ref={this.imageGalleryRef} onScreenChange={this.handleScreenChange} items={imageurl} onThumbnailError={"Images/noimage_new.png"} onClick={this.zoomClick} onSlide={this.handleSlide}
                showPlayButton={false} additionalClass="custom-fullscreen" showThumbnails={this.state.isFullScreen} showBullets={!this.state.isFullScreen && showBullets} showIndex={showIndex} onErrorImageURL={"/Images/noimage_new.png"} />
        )
    }
    zoomClick(event) {
        if (this.imageGalleryRef.current) {
            this.imageGalleryRef.current.fullScreen();
        }
    }
    altPartstoCartResponse = () => {
       
        let Status = JSON.parse(AltPartDetailsStore.addtoCartResponse);
        let message = ""
        console.log("Status_Add", Status)
        let itemstatus = Status._FlagDt
        let iteminsertstatus = Status.SuccessFLag
        if (itemstatus.length > 0) {
            if (itemstatus[0].is_Success == "True" || itemstatus[0].is_Success == "true") {
                CookieService.updateLocalStorageValues("Session_SearchValue", this.state.SearchKeyWord);
                let itemidnotinserted = ""
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    message = "Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care."
                }
                if (iteminsertstatus[0].CORE_CHARGE != "" && iteminsertstatus[0].CORE_CHARGE != " " && iteminsertstatus[0].CORE_CHARGE != null) {
                    message = "Item successfully added to cart and added item applies core charges"
                }
                else {
                    message = "Item successfully added to cart"
                }
            }
            else {
                CookieService.updateLocalStorageValues("Session_SearchValue", this.state.SearchKeyWord);
                let itemidnotinserted = ""
                let validate = false
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                        else if (validate != true && val.Status == "true") {
                            validate = true
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    message = "Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care."
                }
                if (validate == true) {

                    //window.location.reload();
                    //[12/22/21], PC_SR_04, WW-286, Dhevanesam R
                    if (iteminsertstatus[0].CORE_CHARGE != "" && iteminsertstatus[0].CORE_CHARGE != " " && iteminsertstatus[0].CORE_CHARGE != null) {
                        message = "Item successfully added to cart and added item applies core charges"
                    }
                    else {
                        message = "Item successfully added to cart"
                    }
                }
                else if (itemidnotinserted == null || itemidnotinserted == undefined || itemidnotinserted == "") {
                    message = "Techincal Issue Contact SDI Customer Care"
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
                else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            }
        }
        this.closePopup(message);
    }
    altPartDetailsResponse = () => {
        
        let PageLoadResponse = JSON.parse(AltPartDetailsStore.altPartDetailsResponse);
        let carouselImgPath = []
        console.log("Result", PageLoadResponse);
        let ItemPrice = PageLoadResponse.ItemPrice;
        let HeaderDetails = PageLoadResponse.HeaderDetails;
        let ItemCatalogPath = PageLoadResponse.ItemCatalogPath;
        let ItemData = PageLoadResponse.ItemData;
        let Update_Session = PageLoadResponse.Update_Session;
        let QuantityAvail = PageLoadResponse.QuantityAvail;
        //[1/10/23, WW-542_PC_15, Dhevanesam R]
        let Error_Message = PageLoadResponse.Error_Message;
        let ExtendDesc = ""
        let ExtendDescLink = 0
        let QtyDisableValue = false
        if (ExtendDesc.length > 0 && ExtendDesc != "None") {
            ExtendDescLink = 1
        }
        //

        if (Error_Message != undefined && Error_Message != null && Error_Message.length != 0) {
            if (Error_Message[0].ErrorMessage != null) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: Error_Message[0].ErrorMessage
                });
            }
        }
        else {
            if (ItemData != undefined && ItemData != null) {
                if (ItemData.length > 0) {
                    if (ItemData[0].AttributeValue != null) {
                        if (ItemData[0].AttributeValue.trim() == "BATTERY" || ItemData[0].AttributeValue.trim() == "CHARGER") {
                            QtyDisableValue = true
                        }
                    }
                    let ImageData = ItemData[0].ThumbnailImagefile;
                    let imagePath = ""
                    let imgArr = ImageData.split("|")
                    let FirstImage = imgArr[0];
                    ExtendDesc = ItemData[0].ExtndDesc;
                    imgArr.map((val, index) => {
                        let imagePath = "";
                        if (val) {
                            ItemData[0].Image = val.replace('\\', '/');
                            if (ItemData[0].Image.toLowerCase().indexOf("http") >= 0) {
                                imagePath = val;
                            } else {
                                imagePath = ItemData[0].ThumbnailImagefile.lastIndexOf(`/`) >= 0 ? ItemData[0].ThumbnailImagefile.substring(ItemData[0].ThumbnailImagefile.lastIndexOf("/") + 1, ItemData[0].ThumbnailImagefile.length) : "noimage_new.png";
                                if (imagePath) {
                                    imagePath = `/Images/${imagePath}`;
                                }
                            }
                        } else {
                            imagePath = `/Images/noimage_new.png`;
                        }
                        ItemImageValue = imagePath
                        let locArray = {
                            original: imagePath,
                            thumbnail: imagePath
                        }
                        carouselImgPath.push(locArray)
                    })
                    let message = this.calcWorkingDaysNew(ItemData[0].ships_within)//*****NEW****wal-158(GetShipwithin()-->calcWorkingDays)
                    console.log("GetShipwithin", message)
                    let Iconflag = true
                    let qty = ItemData[0].min_order_qty != null && ItemData[0].min_order_qty != "" && ItemData[0].min_order_qty != undefined ? ItemData[0].min_order_qty : "-";
                    let favitem = false
                    if (this.state.IsFromFav) {
                        favitem = true
                    }
                    if (this.state.IsShopCartFav) {
                        favitem = true
                    }
                    let Bentonville = ItemData[0].actual_qty;
                    let CentralWare = "";
                    if (Bentonville != null && Bentonville != "" && Bentonville != undefined) {
                        CentralWare = Bentonville.slice(-1);
                    }
                    this.setState({
                        isAltDetailClick: true,
                        ItemTypeFav: "CAT",
                        ImageURL: ItemData[0].ThumbnailImagefile != null && ItemData[0].ThumbnailImagefile != "" && ItemData[0].ThumbnailImagefile != undefined ? ItemData[0].ThumbnailImagefile : "-",
                        ItemId: ItemData[0].customerPartnumber_CatalogZero != null && ItemData[0].customerPartnumber_CatalogZero != "" && ItemData[0].customerPartnumber_CatalogZero != undefined ? ItemData[0].customerPartnumber_CatalogZero : "-",
                        ItemNoun: "-", ItemDetail: ItemData[0],
                        PackageQuantity: ItemData[0].package_qty != null && ItemData[0].package_qty != "" && ItemData[0].package_qty != undefined ? ItemData[0].package_qty : "-",
                        ShipWIthin: message.Sampletest != "" && message.Sampletest != null && message.Sampletest != undefined ? message.Sampletest : "",
                        ItemManufacturerName: ItemData[0].manufacturer != null && ItemData[0].manufacturer != "" && ItemData[0].manufacturer != undefined ? ItemData[0].manufacturer : "-",
                        ItemfeatureDesc: ItemData[0].description != null && ItemData[0].description != "" && ItemData[0].description != undefined ? ItemData[0].description : "-",
                        ItemClientPartNum: ItemData[0].clientPartNumber != null && ItemData[0].clientPartNumber != "" && ItemData[0].clientPartNumber != undefined ? ItemData[0].clientPartNumber : "-",
                        ItemDescription: ItemData[0].longdescriptionone != null && ItemData[0].longdescriptionone != "" && ItemData[0].longdescriptionone != undefined && ItemData[0].longdescriptionone != "\N" ? ItemData[0].longdescriptionone : "-",
                        spec_sheet: ItemData[0].spec_sheet != undefined && ItemData[0].spec_sheet != null ? ItemData[0].spec_sheet.includes("http") ? ItemData[0].spec_sheet : "-" : "",
                        doc_data_sheet: ItemData[0].doc_data_sheet != undefined && ItemData[0].doc_data_sheet != null ? ItemData[0].doc_data_sheet.includes("http") ? ItemData[0].doc_data_sheet : "-" : "",
                        doc_install_operator: ItemData[0].doc_install_operator != undefined && ItemData[0].doc_install_operator != null ? ItemData[0].doc_install_operator.includes("http") ? ItemData[0].doc_install_operator : "-" : "",
                        msds_sds: ItemData[0].msds_sds != undefined && ItemData[0].msds_sds != null ? ItemData[0].msds_sds.includes("http") ? ItemData[0].msds_sds : "-" : "",
                        doc_parts: ItemData[0].doc_parts != undefined && ItemData[0].doc_parts != null ? ItemData[0].doc_parts.includes("http") ? ItemData[0].doc_parts : "-" : "",
                        cad_drawing: ItemData[0].cad_drawing != undefined && ItemData[0].cad_drawing != null ? ItemData[0].cad_drawing.includes("http") ? ItemData[0].cad_drawing : "-" : "",
                        AttributeName: ItemData[0].AttributeName != null && ItemData[0].AttributeName != "" && ItemData[0].AttributeName != undefined ? ItemData[0].AttributeName : null,
                        AttributeValue: ItemData[0].AttributeValue != null && ItemData[0].AttributeValue != "" && ItemData[0].AttributeValue != undefined ? ItemData[0].AttributeValue : null,
                        ItemClient: ItemData[0].clientDesc != null && ItemData[0].clientDesc != "" && ItemData[0].clientDesc != undefined ? ItemData[0].clientDesc : "-",
                        ItemGroup: HeaderDetails.length > 0 ? HeaderDetails[0].INV_ITEM_GROUP : "-",
                        ItemCatalogPath: ItemCatalogPath[0].ItemCatalogPath != null && ItemCatalogPath[0].ItemCatalogPath != "" && ItemCatalogPath[0].ItemCatalogPath != undefined ? ItemCatalogPath[0].ItemCatalogPath : "-",
                        ItemUOM: ItemData[0].UOM != null && ItemData[0].UOM != "" && ItemData[0].UOM != undefined ? ItemData[0].UOM : "-",
                        ItemCategory: HeaderDetails.length > 0 ? HeaderDetails[0].CATEGORY_ID : "-",
                        ItemModifiers: HeaderDetails.length > 0 ? HeaderDetails[0].IM_MODIFIER : "-",
                        ItemMFGPartNumber: ItemData[0].manfPartnumber != null && ItemData[0].manfPartnumber != "" && ItemData[0].manfPartnumber != undefined ? ItemData[0].manfPartnumber : "-",
                        ItemUNSPSC: ItemData[0].UNSPSC != null && ItemData[0].UNSPSC != "" && ItemData[0].UNSPSC != undefined ? ItemData[0].UNSPSC : "-",
                        ItemSDICatagory: ItemData[0].UNSPSCCategory != null && ItemData[0].UNSPSCCategory != "" && ItemData[0].UNSPSCCategory != undefined ? ItemData[0].UNSPSCCategory : "-",
                        ItemType: HeaderDetails.length > 0 ? HeaderDetails[0].INV_ITEM_TYPE : "-",
                        ItemQuantityAvail: QuantityAvail[0].QuantityAvail,
                        ItemImage: carouselImgPath,
                        ImagePath: ItemData[0].ThumbnailImagefile,
                        ItemCurrencyCOde: CookieService.getLocalStorageValues("Search_lblCurrencyCode"),
                        ExtentDescription: ItemData[0].ExtndDesc != null && ItemData[0].ExtndDesc != "" && ItemData[0].ExtndDesc != undefined && ItemData[0].ExtndDesc != "\N" ? ItemData[0].ExtndDesc : "-",
                        ShowExtentDespPopUp: ExtendDescLink,
                        ItemSupplierName: ItemData[0].supplierName != null && ItemData[0].supplierName != "" && ItemData[0].supplierName != undefined ? ItemData[0].supplierName : "-",
                        ItemPrice: ItemData[0].ItemPrice,
                        supplier_part_number: ItemData[0].supplier_part_number != null && ItemData[0].supplier_part_number != "" && ItemData[0].supplier_part_number != undefined ? ItemData[0].supplier_part_number : "-",
                        FavItem: CookieService.getLocalStorageValues("Search_ItemFav"),
                        SAP_Article_Number: ItemData[0].customer_part_number_woprefix != null && ItemData[0].customer_part_number_woprefix != "" && ItemData[0].customer_part_number_woprefix != undefined && ItemData[0].customer_part_number_woprefix != " " ? ItemData[0].customer_part_number_woprefix : "-",
                        actual_qty: ItemData[0].actual_qty != null && ItemData[0].actual_qty != undefined ? ItemData[0].actual_qty : "", carticonFlag: Iconflag, mfg_part_std: ItemData[0].mfg_part_std,
                        MIN_ORD_QTY: ItemData[0].min_order_qty != null && ItemData[0].min_order_qty != "" && ItemData[0].min_order_qty != undefined ? ItemData[0].min_order_qty : "-",
                        Quantityvalue: qty,
                        Short_desc: ItemData[0].short_desc != null && ItemData[0].short_desc != "" && ItemData[0].short_desc != undefined && ItemData[0].short_desc != "\N" ? ItemData[0].short_desc : "-",
                        Long_Desc: ItemData[0].longdescriptionone != null && ItemData[0].longdescriptionone != "" && ItemData[0].longdescriptionone != undefined & ItemData[0].longdescriptionone != "\N" ? ItemData[0].longdescriptionone : "-",
                        FavItem: favitem,
                        BenItemIcon: CentralWare, VendorId: ItemData[0].vendor_id != null && ItemData[0].vendor_id != "" && ItemData[0].vendor_id != undefined ? ItemData[0].vendor_id : "", //WW-522, 
                        QtyDisable: QtyDisableValue,
                        equParts: ItemData[0].alternate_parts != null && ItemData[0].alternate_parts != "" && ItemData[0].alternate_parts != undefined ? JSON.parse(ItemData[0].alternate_parts) : [],//' PC_WW-641_05-Priyanka  D
                        alsoFits: ItemData[0].alsoFits != null && ItemData[0].alsoFits != "" && ItemData[0].alsoFits != undefined ? JSON.parse(ItemData[0].alsoFits) : [],//' PC_WW-641_05-Priyanka  D

                    })
                }
            }
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }


    calcWorkingDaysNew(shipwithin) {
        
        let count = 0;
        let today = new Date()
        console.log("today's date", today)
        console.log("no.of days", shipwithin)
        while (count < shipwithin) {
            if (today.getDay() != 0 && today.getDay() != 6) // Skip weekends
            {
                count++;
            }
            //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
            today.setDate(today.getDate() + 1);
        }
        //WW-357(Catalog Lead Times Based on Real Data vs. Supplier Best Case) - Deepthi N H
        today.setDate(today.getDate() - 1);
        let td = this.handledate(today);
        let Sampletest = "" + td
        return Sampletest;
    }
    handledate = (date) => {
        if (date != null) {
            return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
        }
    }
    selectAltParts = (value) => {

        let altDetails = this.props.altDetails
        let nonCatItemDetails = this.state.nonCatItemDetails
        let index = altDetails.findIndex(item => item.manfPartNumber === value.manfPartNumber && item.manufacturer == value.manufacturer && item.vendor_id == value.vendor_id && item.supplier_part_number == value.supplier_part_number);
        altDetails[index].IsSelected = !value.IsSelected;
        let ShipByDate = this.calcWorkingDaysNew(value.ships_within);
        let locArray = {
            ItemId: value.clientPartNumber,
            txtSupplier: value.supplierName,
            txtSupplierID: value.vendor_id,
            txtSuppPartNum: value.supplier_part_number,
            txtEstPrice: value.ItemPrice,
            txtDesc: value.Description,
            txtMfgPartNum: value.manfPartNumber,
            txtMfgName: value.manufacturer,
            txtQty: value.QuantityOrdered,
            image_url: value.ThumbnailImagefile,
            DropUOM: value.UOM,
            rblcatalogVisible: false,
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            filePath: null,
            EMPCC: "",
            DUeDate: ShipByDate,
            Type: "",
            MachineNo: "",
            Notes: "",
            Priority: "",
            SAP_ARTCILE_NUMBER: value.customer_part_number_woprefix,
            ItemCat: value.UNSPSC,
            MIN_ORD_QTY: value.min_order_qty,
        }
        if (altDetails[index].IsSelected == true) {
            nonCatItemDetails.push(locArray)
        } else {
            let index = nonCatItemDetails.findIndex(item => item.manfPartNumber === value.manfPartNumber && item.manufacturer == value.manufacturer && item.vendor_id == value.vendor_id && item.supplier_part_number == value.supplier_part_number);
            nonCatItemDetails.splice(index, 1)
        }
        this.setState({ nonCatItemDetails: nonCatItemDetails, altDetails })
    }
    handleEditQuantity = (e, value, action) => {
        
        let val = e.target.value;
        if (val.length > 5) {
            return;
        }
        let altDetails = this.props.altDetails

        let re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {
            let QtyToBeChanged = e.target.value;
            if (action == "AltDetails") {
                this.setState({ Quantityvalue: QtyToBeChanged });
            } else {
                let index = altDetails.findIndex(item => item.manfPartNumber === value.manfPartNumber && item.manufacturer == value.manufacturer && item.vendor_id == value.vendor_id && item.supplier_part_number == value.supplier_part_number);
                altDetails[index].QuantityOrdered = e.target.value;
                this.setState({ altDetails })
            }
        }


    }
    handleMinOrderQuantity = (e, value, action) => {

        let altDetails = this.props.altDetails
        let Quantityvalue
        let MinOrdQty
        let updatedQty
        let index = altDetails.findIndex(item => item.manfPartNumber === value.manfPartNumber && item.manufacturer == value.manufacturer && item.vendor_id == value.vendor_id && item.supplier_part_number == value.supplier_part_number);
        if (action == "AltDetails") {
            Quantityvalue = this.state.Quantityvalue
            MinOrdQty = this.state.MIN_ORD_QTY
            updatedQty = this.state.Quantityvalue
        } else {
            Quantityvalue = value.QuantityOrdered
            MinOrdQty = value.min_order_qty
            updatedQty = value.QuantityOrdered
        }
        let QtyToBeChanged = "";
        if ((parseInt(Quantityvalue) % parseInt(MinOrdQty)) != 0) {
            if (parseInt(Quantityvalue) < parseInt(MinOrdQty)) {
                updatedQty = MinOrdQty
            }
            else if (parseInt(Quantityvalue) > parseInt(MinOrdQty)) {
                if (e.target.value == "+") {
                    let IsValidqty = false
                    let MinQty = MinOrdQty;
                    while (!IsValidqty) {
                        if (parseInt(MinQty) < parseInt(Quantityvalue)) {
                            MinQty = parseInt(MinQty) + parseInt(MinOrdQty);
                        }
                        else if (parseInt(MinQty) > parseInt(Quantityvalue)) {
                            let diff = parseInt(MinQty) - parseInt(Quantityvalue);
                            if (diff <= parseInt(MinOrdQty)) {
                                QtyToBeChanged = MinQty;
                                updatedQty = QtyToBeChanged
                                IsValidqty = true;
                            }
                        }
                    }


                }
                else if (e.target.value == "-") {
                    let IsValidqty = false
                    let MinQty = MinOrdQty;
                    while (!IsValidqty) {
                        if (parseInt(MinQty) < parseInt(Quantityvalue)) {
                            let diff = parseInt(Quantityvalue) - parseInt(MinQty);
                            if (diff <= MinOrdQty) {
                                QtyToBeChanged = MinQty;
                                updatedQty = QtyToBeChanged
                                IsValidqty = true;
                            }
                            else {
                                MinQty = parseInt(MinQty) + parseInt(MinOrdQty);
                            }

                        }
                    }
                }
            }
        }
        else {
            if (e.target.value == "+") {
                QtyToBeChanged = parseInt(Quantityvalue) + parseInt(MinOrdQty);
                updatedQty = QtyToBeChanged
            }
            else if (e.target.value == "-") {
                QtyToBeChanged = parseInt(Quantityvalue) - parseInt(MinOrdQty);
                if (parseInt(QtyToBeChanged) < parseInt(MinOrdQty)) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: 'You Cannot Decrement Below the Minimum Order Quantity'
                    });
                    return;
                }
                else if (QtyToBeChanged == 0 || QtyToBeChanged == "0") {
                    e.preventDefault();
                }
                else {
                    updatedQty = QtyToBeChanged
                }
            }
        }
        if (action == "AltDetails") {
            this.setState({ Quantityvalue: updatedQty })
        } else {
            altDetails[index].QuantityOrdered = updatedQty
            this.setState({ altDetails })
        }

    };
    altPartsCartClick = (value, isItemDetail) => {
        let nonCatItemDetails = []
        let locArray = {}
        if (!isItemDetail) {
            let ShipByDate = this.calcWorkingDaysNew(value.ships_within);
            locArray = {
                ItemId: value.clientPartNumber,
                txtSupplier: value.supplierName,
                txtSupplierID: value.vendor_id,
                txtSuppPartNum: value.supplier_part_number,
                txtEstPrice: value.ItemPrice,
                txtDesc: value.Description,
                txtMfgPartNum: value.manfPartNumber,
                txtMfgName: value.manufacturer,
                txtQty: value.QuantityOrdered,
                image_url: value.ThumbnailImagefile,
                DropUOM: value.UOM,
                rblcatalogVisible: false,
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                filePath: null,
                EMPCC: "",
                DUeDate: ShipByDate,
                Type: "",
                MachineNo: "",
                Notes: "",
                Priority: "",
                SAP_ARTCILE_NUMBER: value.customer_part_number_woprefix,
                ItemCat: value.UNSPSC,
                MIN_ORD_QTY: value.min_order_qty,
            }
        } else {
            locArray = {
                ItemId: this.state.ItemId,
                txtSupplier: this.state.ItemSupplierName,
                txtSupplierID: this.state.VendorId,
                txtSuppPartNum: this.state.ItemClientPartNum,
                txtEstPrice: this.state.ItemPrice,
                txtDesc: this.state.ItemDescription,
                txtMfgPartNum: this.state.ItemMFGPartNumber,
                txtMfgName: this.state.ItemManufacturerName,
                txtQty: this.state.Quantityvalue,
                image_url: this.state.ImagePath,
                DropUOM: this.state.ItemUOM,
                rblcatalogVisible: false,
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                filePath: "",
                EMPCC: "",
                DUeDate: this.state.DueDate,
                Type: "",
                MachineNo: "",
                Notes: "",
                Priority: "",
                SAP_ARTCILE_NUMBER: this.state.SAP_Article_Number,
                ItemCat: this.state.Item_cat,
                MIN_ORD_QTY: this.state.MIN_ORD_QTY,
                //[12/22/21], PC_SR_02, WW-286, Dhevanesam R
                CORE_CHARGE: this.state.ItemDetail.core_charges
            }
        }
        nonCatItemDetails.push(locArray)
        this.altPartstoCart(nonCatItemDetails)
    }
    altPartstoCart = (nonCatItemDetails) => {

        let minQtyMissMatch = []
        let qtyMissMatchList = []

        // let nonCatItemDetails = nonCatItemDetails;
        nonCatItemDetails.forEach((ItemDetail) => {

            if (parseInt(ItemDetail.txtQty) < parseInt(ItemDetail.MIN_ORD_QTY)) {
                minQtyMissMatch.push(ItemDetail.ItemId)
            }
            else if ((parseInt(ItemDetail.txtQty) % parseInt(ItemDetail.MIN_ORD_QTY)) != 0) {
                minQtyMissMatch.push(ItemDetail.ItemId)
            }

        })
        if (minQtyMissMatch.length > 0) {
            qtyMissMatchList = minQtyMissMatch.join(",")
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: " Entered Quantity Does Not Match the Minimum Order Quantity Sequence for the item " + qtyMissMatchList
            });

        }

        else {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            let AddToCartBO = {
                ItemDetails: [],
                NonItemDetails: nonCatItemDetails,
                Session_BUSUNIT: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
                Session_USERID: (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID")),
                Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                Session_ImageLocPath: "",
                Session_PUNCHIN: "False",
                MobileAPICall: false,
                Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna
                SOURCE: "WEB"
            }



            AltPartDetailsAction.altPartstoCart(AddToCartBO)
            //WW-685 SIT-1 retesting Bug fixing Pavithra R
            this.state.altDetails.forEach((value, index) => value.IsSelected = false)
        }
    }
    bindUnAvailItems = () => {
       
        let unAvailArr = []
        let unAvailItemList = []
        this.props.flagTable.map((val, index) => {
            unAvailArr.push(val.Item_ID)
        });
        if (unAvailArr.length > 0) {
            unAvailItemList = unAvailArr.join(",")
        }
        return (
            <div class="modal-body">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 carousel-scroll">
                        <p class="font-14 mt-3 d-flex align-items-center">
                            <img src="images/warning.svg" alt="warning-img" class="pr-2" />
                            <span class="modal-inner-label mr-2 ">NOTE:</span> Item
                        <span class="modal-inner-label px-1"> {unAvailItemList} </span>
                            {unAvailItemList.length > 1 ? <span class="modal-inner-label ">  is not available </span> :
                                <span class="modal-inner-label ">  are not available </span>
                            }
                        </p>
                        {this.bindAltParts()}
                    </div>
                </div>
            </div>
        );
    }
    altPartDetailsClick = (e, value) => {
        if (e) {
            e.preventDefault();
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let ItemDetailNewBO = {
            Session_BUSUNIT: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
            Session_USERID: (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID")),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
            ItemID: value.clientPartNumber,
            Manufacture_Part: value.manfPartNumber,
            Session_SITELANG: CookieService.getLocalStorageValues("Session_SITELANG"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_Noncat: CookieService.getLocalStorageValues("Session_Noncat"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Query_ItemAttributeId: "",//CookieService.getLocalStorageValues("Search_ItemAttributeId"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Manufacture_Name: value.manufacturer,
            Supplier_id: value.vendor_id,
            Ship_To: CookieService.getLocalStorageValues("HOME_STORE"),//Pass the value of Home store to Shipto 
            Session_ID: CookieService.getLocalStorageValues("Session_ID"),//WW-390_PC_06 (4/20/2022)-Aparna
            LAST_ITEM_VENDOR_ID: "",//WW-390_PC_06 (4/20/2022)-Aparna
            LAST_ITEM_VENDOR_ITEM_ID: "",//WW-390_PC_06 (4/20/2022)-Aparna
            SOURCE: "WEB",
            IsSupplierSearch: true,
            AlternatePartDetail: false,
            Location: CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
        }
     
        console.log("ItemDetailNewBO", ItemDetailNewBO)
        AltPartDetailsAction.altPartDetailsClick(ItemDetailNewBO)
    }
    bindUnavailPartsMob = (val, altDetails) => {
        return altDetails.map((value, index) => {
           
            // let MinOrdQty = "" + val.min_order_qty;
            // let MaxOrdQty = "" + (parseInt(val.min_order_qty) + parseInt(val.min_order_qty));
            let longdescriptionone = "NA"
            let imagePath = `/Images/item-card-img.png`;
            if (value.longdescriptionone != "\N" && value.longdescriptionone != null) {
                longdescriptionone = value.longdescriptionone
            }
            let ThumbnailImagefile = value.ThumbnailImagefile.split("|")
            if (ThumbnailImagefile[0]) {
                value.Image = ThumbnailImagefile[0].replace('\\', '/');
                if (value.Image.toLowerCase().indexOf("http") >= 0) {
                    imagePath = ThumbnailImagefile[0];
                } else {
                    imagePath = ThumbnailImagefile[0].lastIndexOf(`/`) >= 0 ? ThumbnailImagefile[0].substring(ThumbnailImagefile[0].lastIndexOf("/") + 1, ThumbnailImagefile[0].length) : "item-card-img.png";
                    if (imagePath) {
                        imagePath = `/Images/${imagePath}`;
                    }
                }
            } else {
                imagePath = `Images/item-card-img.png`;
            }
            if (imagePath.includes("NoImageAvailable")) {
                imagePath = `Images/item-card-img.png`;
            }
            return (
                <div class="col-md-6 col-sm-12 col-12">
                    <div class="item-card position-relative">
                        <input type="checkbox" class="sdi-checkbox position-absolute image-check" id="img-check" checked={value.IsSelected} onClick={(e) => this.selectAltParts(value)} />
                        <img src={imagePath} altSrc="Images/item-card-img.png" onerror="Images/item-card-img.png" for="img-check" class="w-100 item-card-img border-bottom"
                            onClick={(e) => this.altPartDetailsClick(e, value)} />
                        <div class="border-bottom py-2 px-3">
                            <p class="mb-1"><a href="#" class="font-14 d-flex align-items-center" onClick={(e) => this.altPartDetailsClick(e, value)}>{value.manfPartNumber} <span
                                class="ml-1"><img src="images/External_Link.svg" /></span></a></p>
                            <p class="font-14 mb-1 altparts">{longdescriptionone}</p>
                        </div>
                        <div class="d-flex justify-content-between p-3">
                            <div class="d-flex align-items-center">
                                <label class="pr-1 font-14">Qty :</label>
                                <div class="input-group q-box border-left border-right border-top border-bottom" >
                                    <div class="input-group-prepend" style={{ width: "20px" }}>
                                        <button class="btn border -0" type="button" value="-" onClick={(e) => this.handleMinOrderQuantity(e, value, "")}>-</button>
                                    </div>
                                    <input type="text" value={value.QuantityOrdered} title="Qty" pattern="" inputmode="" maxLength={5} onChange={(e) => this.handleEditQuantity(e, value, "")} class="form-control" />
                                    <div class="input-group-prepend" style={{ width: "24px" }}>
                                        <button class="btn border  rounded-right" value="+" type="button" onClick={(e) => this.handleMinOrderQuantity(e, value, "")}>+</button>
                                    </div>
                                </div>
                            </div>
                            <button class="py-2 px-3 custom-btn-primary border-0 rounded" onClick={(e) => this.altPartsCartClick(value, false)}><img
                                src="images/shopping-cart-white-version.svg" /></button>
                        </div>
                    </div>
                </div>
            );
        })
    }
    bindUnavailParts = (val, altDetails) => {

        return altDetails.map((value, index) => {

            if (index >= val.startIndex && index < val.startIndex + 4) {
                let longdescriptionone = "NA"
                let imagePath = `/Images/item-card-img.png`;
                if (value.longdescriptionone != "\N" && value.longdescriptionone != null) {
                    longdescriptionone = value.longdescriptionone
                }
                let ThumbnailImagefile = value.ThumbnailImagefile.split("|")
                if (ThumbnailImagefile[0]) {
                    value.Image = ThumbnailImagefile[0].replace('\\', '/');
                    if (value.Image.toLowerCase().indexOf("http") >= 0) {
                        imagePath = ThumbnailImagefile[0];
                    } else {
                        imagePath = ThumbnailImagefile[0].lastIndexOf(`/`) >= 0 ? ThumbnailImagefile[0].substring(ThumbnailImagefile[0].lastIndexOf("/") + 1, ThumbnailImagefile[0].length) : "item-card-img.png";
                        if (imagePath) {
                            imagePath = `/Images/${imagePath}`;
                        }
                    }
                } else {
                    imagePath = `Images/item-card-img.png`;
                }
                if (imagePath.includes("NoImageAvailable")) {
                    imagePath = `Images/item-card-img.png`;
                }
                return (
                    <div class="col-md-3">
                        <div class="item-card position-relative">
                            <input type="checkbox" class="sdi-checkbox position-absolute image-check" id="img-check" checked={value.IsSelected} onClick={(e) => this.selectAltParts(value)} />
                            <img src={imagePath} altSrc="Images/item-card-img.png" onerror="Images/item-card-img.png" for="img-check" class="w-100 item-card-img border-bottom"
                                onClick={(e) => this.altPartDetailsClick(e, value)} />
                            <div class="border-bottom py-2 px-3">
                                <p class="mb-1"><a href="#" class="font-14 d-flex align-items-center" onClick={(e) => this.altPartDetailsClick(e, value)}>{value.manfPartNumber} <span
                                    class="ml-1"><img src="images/External_Link.svg" /></span></a></p>
                                <p class="font-14 mb-1 altparts">{longdescriptionone}</p>
                            </div>
                            <div class="d-flex justify-content-between p-3">
                                <div class="d-flex align-items-center">
                                    <label class="pr-1 font-14">Qty :</label>
                                    <div class="input-group q-box border-left border-right border-top border-bottom" >
                                        <div class="input-group-prepend" style={{ width: "20px" }}>
                                            <button class="btn border -0" type="button" value="-" onClick={(e) => this.handleMinOrderQuantity(e, value, "")}>-</button>
                                        </div>
                                        <input type="text" value={value.QuantityOrdered} onChange={(e) => this.handleEditQuantity(e, value, "")} class="form-control" />
                                        <div class="input-group-prepend" style={{ width: "24px" }}>
                                            <button class="btn border  rounded-right" value="+" type="button" onClick={(e) => this.handleMinOrderQuantity(e, value, "")}>+</button>
                                        </div>
                                    </div>
                                </div>
                                <button class="py-2 px-3 custom-btn-primary border-0 rounded" onClick={(e) => this.altPartsCartClick(value, false)}><img
                                    src="images/shopping-cart-white-version.svg" /></button>
                            </div>
                        </div>
                    </div>
                );
            }

        })
    }
    closePopup = (message) => {
        this.setState({ isAltDetailClick: false })
        this.props.closePopup(message)
    }
    altPartsScrollClick = (action, val) => {
        let flagTable = this.props.flagTable
        flagTable.map((item, index) => {
            if (item.Item_ID == val.Item_ID) {
                if (action == "up") {
                    item.startIndex = item.startIndex + 4
                } else {
                    item.startIndex = item.startIndex - 4
                }
            }
        })
        this.setState({ flagTable })
    }
    handleToggleChange = (checked) => {
        if (checked == true) {
            this.setState({ ItemDescription: this.state.Short_desc, Description: "Short description" })
        } else {
            this.setState({ ItemDescription: this.state.Long_Desc, Description: "Long description" })

        }
        this.setState({ toggleChecked: checked });
    }
    handleDotclick = () => {
        this.setState({ IsDotClick: true })
    }
    ShowAltDetails = (e) => {
        this.setState({ isAltDetailClick: false })
        if (e) {
            e.preventDefault();
        }
    }


    bindAltParts = () => {
        return this.props.flagTable.map((val, index) => {
            let altDetails = this.props.altDetails.filter((x) => x.AlternateItemID.includes(val.Item_ID))
            let recordCount = 4
            if (window.innerWidth < "767") {
                if (altDetails.length > 2) {
                    recordCount = 1
                } else {
                    recordCount = altDetails.length
                }
            } else if (window.innerWidth < "1200") {
                if (altDetails.length > 3) {
                    recordCount = 2
                } else {
                    recordCount = altDetails.length
                }
            } else {
                if (altDetails.length > 5) {
                    recordCount = 4
                } else {
                    recordCount = altDetails.length
                }
            }
            if (altDetails.length > 0) {
                return (
                    <div>
                        <div class="w-100 d-flex justify-content-between">
                            <p class="font-14 mt-3 col-md-8"><span class="modal-inner-label">Alternate Parts </span><span class="px-1">for
                        </span><span class="modal-inner-label">{val.Item_ID}</span></p>
                            <p class="font-14 mt-3 text-align-right">Showing Records {recordCount} out of {altDetails.length} </p>
                        </div>
                        <div class="row justify-content-center align-items-center border-bottom pb-4">
                            {altDetails.length > 4 && val.startIndex > 0 ?
                                <button class="p-2 border-1 rounded right-arrow-slick d-none d-md-none d-lg-none d-xl-block" onClick={(e) => this.altPartsScrollClick("down", val)}>
                                    <img src="images/right-arrow-slick.svg" /></button> : null
                            }
                            <div class="col-md-11 d-none d-md-none d-lg-none d-xl-block">
                                <div class="row ">
                                    {this.bindUnavailParts(val, altDetails)}
                                </div>
                            </div>
                            <div class="col-md-12 d-lg-block d-xl-none">
                                <div class="row mobile-scroll-img-card">
                                    {this.bindUnavailPartsMob(val, altDetails)}
                                </div>
                            </div>

                            {altDetails.length > 4 && val.startIndex + 4 < altDetails.length ?
                                <button class="p-2 border-1 rounded right-arrow-slick transform-180 d-none d-md-none d-lg-none d-xl-block" onClick={(e) => this.altPartsScrollClick("up", val)}>
                                    <img src="images/right-arrow-slick.svg" />
                                </button> : null
                            }
                        </div>
                    </div>
                );


            }
        })
    }

    render() {
        return (
            (this.state.isAltDetailClick != true ?
                <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header sp-delv-header">
                            <h5 class="modal-title" id="exampleModalLongTitle">Alert</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={(e) => this.closePopup("")}>
                                <span aria-hidden="true">    X </span>
                            </button>
                        </div>
                        {this.props.flagTable != undefined ? this.bindUnAvailItems() : null}
                        <div class="modal-footer border-0 pt-0">
                            <button class="btn btn-secondary custom-btn-secondary secondary-btn float-right mr-2 mb-2" onClick={(e) => this.closePopup("")}>Cancel</button>
                            {this.state.altDetails.filter((x) => x.IsSelected == true).length > 0 ?
                                <button class="btn btn-primary custom-btn-primary primary-btn float-right mr-2 mb-2" onClick={(e) => this.altPartstoCart(this.state.nonCatItemDetails)}>Add to Cart</button> : null}
                        </div>
                    </div>
                </div> :
                <div>

                    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div class="modal-content">
                            <div class="modal-header sp-delv-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Alternate Part Details</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={(e) => this.closePopup("")} >
                                    <span aria-hidden="true">    X </span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <h6 class="modal-inner-heading border-bottom m-0 pb-3"><a href="#" title="back"><img src="images/popup-back.svg" class="pr-2" alt="back-img" onClick={(e) => this.ShowAltDetails(e)} /></a>{this.state.ItemMFGPartNumber}</h6>
                                <div class="row">

                                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 pt-3 ">
                                        <div class="detail-popup-img-container">
                                            {this.bindImage()}
                                        </div>
                                    </div>
                                    <div class="col-12  col-sm-12  col-md-12 col-lg-6 pt-3 ">
                                        <h6 class="modal-inner-heading">{this.state.ItemMFGPartNumber}</h6>
                                        {/* //<p class=" modal-inner-label">Long Description</p>
              //                          <p class="modal-inner-label">{this.state.ItemDescription}</p>*/}
                                        <div className="row mb-3">
                                            {/*[WW-458]Using Toggle button, switch bw Short and long desc-Priyanka D*/}
                                            <div className="col-md-12 col-lg-4 mt-2 catalog-label">{this.state.Description}</div>
                                            <span id="toggle" style={{}}><label>
                                                <Switch
                                                    onChange={() => this.handleToggleChange(!this.state.toggleChecked)}
                                                    checked={this.state.toggleChecked}
                                                    color="primary"
                                                />
                                            </label></span>
                                            {this.state.ItemDescription.length > 356 && !this.state.IsDotClick ?
                                                <div className="col-md-12 col-lg-10 col-auto col-sm-5 catalog-value catalog-id">
                                                    <span>{`${this.state.ItemDescription.substring(0, 356)}`}</span>
                                                    <span style={{ "cursor": "pointer" }} onClick={(e) => this.handleDotclick()} >...</span>
                                                </div>
                                                :
                                                <div className="col-md-12 col-lg-10 catalog-value catalog-id">{this.state.ItemDescription}</div>}
                                        </div>
                                        <div class="form-group row mb-0">
                                            <label for="Delivery-Method-label" class="col-sm-4 col-form-label modal-inner-label">Manufacturer</label>
                                            <label for="Delivery-Method-label" class="col-sm-8 col-form-label modal-inner-label-value">{this.state.ItemManufacturerName}</label>
                                        </div>
                                        <div class="form-group row mb-0">
                                            <label for="Delivery-Method-label" class="col-sm-4 col-form-label modal-inner-label">Supplier</label>
                                            <label for="Delivery-Method-label" class="col-sm-8 col-form-label modal-inner-label-value">{this.state.ItemSupplierName}</label>
                                        </div>
                                        <div class="form-group row mb-0">
                                            <label for="Delivery-Method-label" class="col-sm-4 col-form-label modal-inner-label">Supplier Part#</label>
                                            <label for="Delivery-Method-label" class="col-sm-8 col-form-label modal-inner-label-value">{this.state.supplier_part_number}</label>
                                        </div>
                                        <div class="form-group row mb-0">
                                            <label for="Delivery-Method-label" class="col-sm-4 col-form-label modal-inner-label">Catalog Path</label>
                                            <label for="Delivery-Method-label" class="col-sm-8 col-form-label modal-inner-label-value">{this.state.ItemCatalogPath}</label>
                                        </div>
                                        <div class="form-group row mb-0">
                                            <label for="Delivery-Method-label" class="col-sm-4 col-form-label modal-inner-label">UOM</label>
                                            <label for="Delivery-Method-label" class="col-sm-8 col-form-label modal-inner-label-value">{this.state.ItemUOM}</label>
                                        </div>

                                        <div class="form-group row mb-0">
                                            <label for="Delivery-Method-label" class="col-sm-4 col-form-label modal-inner-label">UNSPSC</label>
                                            <label for="Delivery-Method-label" class="col-sm-8 col-form-label modal-inner-label-value">{this.state.ItemUNSPSC}</label>
                                        </div>


                                        <div class="form-group row mb-0">
                                            <label for="Delivery-Method-label" class="col-sm-4 col-form-label modal-inner-label">Package Quantity</label>
                                            <label for="Delivery-Method-label" class="col-sm-8 col-form-label modal-inner-label-value">{this.state.PackageQuantity}</label>
                                        </div>
                                        <div class="form-group row mb-0">
                                            <label for="Delivery-Method-label" class="col-sm-4 col-form-label modal-inner-label">SAP Article Number</label>
                                            <label for="Delivery-Method-label" class="col-sm-8 col-form-label modal-inner-label-value">{this.state.SAP_Article_Number}</label>
                                        </div>
                                        <div class="form-group row mb-0">
                                            <label for="Delivery-Method-label" class="col-sm-4 col-form-label modal-inner-label">Minimum Order Quantity</label>
                                            <label for="Delivery-Method-label" class="col-sm-8 col-form-label modal-inner-label-value">{this.state.MIN_ORD_QTY}</label>
                                        </div>
                                        <div class="form-group row mb-0">
                                            <label for="Delivery-Method-label" class="col-sm-4 col-form-label modal-inner-label">Total Order QTY</label>
                                            <div class="d-flex align-items-center col-sm-8 col-form-label">
                                                <div class="input-group q-box border-right border-left border-top border-bottom" style={{ width: "126px" }}>
                                                    <div class="input-group-prepend" style={{ width: "20px" }}>
                                                        <button class="btn " type="button" value="-" onClick={(e) => this.handleMinOrderQuantity(e, "", "AltDetails")}>-</button>
                                                    </div>
                                                    <input type="text" value={this.state.Quantityvalue} onChange={(e) => this.handleEditQuantity(e, "", "AltDetails")} class="form-control" />
                                                    <div class="input-group-prepend" style={{ width: "24px" }}>
                                                        <button class="btn  rounded-right" value="+" type="button" onClick={(e) => this.handleMinOrderQuantity(e, "", "AltDetails")}>+</button>
                                                    </div>
                                                </div>
                                                <button class="ml-3 custom-btn-primary border-0 rounded pop-cart-btn" onClick={(e) => this.altPartsCartClick("", true)}><img src="images/shopping-cart-white-version.svg" /></button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="modal-footer border-0 pt-0">
                                <button class="btn btn-secondary custom-btn-secondary secondary-btn float-right mr-2 mb-2" onClick={(e) => this.ShowAltDetails(e)}> Back</button>
                            </div>
                        </div>
                    </div>

                </div>
            )
        );
    }
}
export default AlternatepartsComponent;